import React from "react";
import { Trash } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import { STAGES } from "./constants";

export const BulkActionBar = ({
  selectedIds,
  onClearSelection,
  bulkField,
  onBulkFieldChange,
  bulkValue,
  onBulkValueChange,
  onBulkApply,
  onBulkDelete,
  onMoveToCompleted,
  canDelete,
  isAdmin,
  editors,
  allChannels,
  channelId,
}) => {
  if (selectedIds.length === 0) return null;

  return (
    <div
      className="surface-card mb-3 p-3 flex items-center gap-3 border border-cyan-500/30 bg-cyan-500/5"
      data-testid="bulk-action-bar"
    >
      <span className="text-sm text-cyan-400 font-medium">
        {selectedIds.length} selected
      </span>

      <select
        value={bulkField}
        onChange={(e) => onBulkFieldChange(e.target.value)}
        className="h-8 text-xs rounded bg-white/5 border border-white/10 text-white px-2"
        data-testid="bulk-field-select"
      >
        <option value="">Choose field...</option>
        <option value="priority">Priority</option>
        <option value="stage">Stage</option>
        <option value="type">Type</option>
        <option value="editor">Editor</option>
        <option value="channel">Move to Channel</option>
      </select>

      {bulkField === "priority" && (
        <select
          value={bulkValue}
          onChange={(e) => onBulkValueChange(e.target.value)}
          className="h-8 text-xs rounded bg-white/5 border border-white/10 text-white px-2"
          data-testid="bulk-value-select"
        >
          <option value="">Select...</option>
          <option value="1">1 (Top)</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      )}

      {bulkField === "stage" && (
        <select
          value={bulkValue}
          onChange={(e) => onBulkValueChange(e.target.value)}
          className="h-8 text-xs rounded bg-white/5 border border-white/10 text-white px-2"
          data-testid="bulk-value-select"
        >
          <option value="">Select...</option>
          {STAGES.map((s) => (
            <option key={s} value={s} className="capitalize">
              {s}
            </option>
          ))}
        </select>
      )}

      {bulkField === "type" && (
        <select
          value={bulkValue}
          onChange={(e) => onBulkValueChange(e.target.value)}
          className="h-8 text-xs rounded bg-white/5 border border-white/10 text-white px-2"
          data-testid="bulk-value-select"
        >
          <option value="">Select...</option>
          <option value="long">Long</option>
          <option value="short">Short</option>
        </select>
      )}

      {bulkField === "editor" && (
        <select
          value={bulkValue}
          onChange={(e) => onBulkValueChange(e.target.value)}
          className="h-8 text-xs rounded bg-white/5 border border-white/10 text-white px-2"
          data-testid="bulk-value-select"
        >
          <option value="">Select...</option>
          <option value="__unassign">Unassign</option>
          {editors.map((e) => (
            <option key={e.id} value={e.id}>
              {e.name}
            </option>
          ))}
        </select>
      )}

      {bulkField === "channel" && (
        <select
          value={bulkValue}
          onChange={(e) => onBulkValueChange(e.target.value)}
          className="h-8 text-xs rounded bg-white/5 border border-white/10 text-white px-2"
          data-testid="bulk-value-select"
        >
          <option value="">Select channel...</option>
          {allChannels
            .filter((c) => c.id !== channelId)
            .map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
        </select>
      )}

      <Button
        size="sm"
        onClick={onBulkApply}
        disabled={!bulkField || !bulkValue}
        className="h-8 bg-cyan-600 hover:bg-cyan-500 text-xs"
        data-testid="bulk-apply-btn"
      >
        Apply
      </Button>

      {canDelete && (
        <Button
          size="sm"
          onClick={onBulkDelete}
          variant="destructive"
          className="h-8 text-xs"
          data-testid="bulk-delete-btn"
        >
          <Trash size={14} className="mr-1" />
          Delete ({selectedIds.length})
        </Button>
      )}

      {isAdmin && (
        <Button
          size="sm"
          onClick={onMoveToCompleted}
          variant="outline"
          className="h-8 text-xs border-amber-500/30 text-amber-400 hover:bg-amber-500/10"
          data-testid="bulk-complete-btn"
        >
          Move to Completed
        </Button>
      )}

      <button
        onClick={onClearSelection}
        className="text-xs text-gray-400 hover:text-white ml-auto"
      >
        Clear selection
      </button>
    </div>
  );
};
